import { handleVersionMismatch } from 'actions/versionSync';
import * as StoryletActionTypes from 'actiontypes/storylet';
import { VersionMismatch } from 'services/BaseService';
import StoryletService from 'services/StoryletService';
import fetchAvailable from './fetchAvailable';
import IStoryletService from 'types/storylet/service';

/** ----------------------------------------------------------------------------
 * BEGIN SOCIAL EVENT
 -----------------------------------------------------------------------------*/
export default beginSocialEvent(new StoryletService());

export function beginSocialEvent(service: IStoryletService) {
  return (invitationId: number) => async (dispatch: Function) => {
    dispatch(beginSocialEventRequested(invitationId));

    try {
      const { data } = await service.beginSocialEvent(invitationId);
      if (data.isSuccess) {
        dispatch(beginSocialEventSuccess());
        dispatch(fetchAvailable()); // Get slets for this social event
      } else {
        dispatch(beginSocialEventUnavailable(data));
      }
      // Return the data
      return data;
    } catch (error) {
      if (error instanceof VersionMismatch) {
        dispatch(handleVersionMismatch(error));
      }
      dispatch(beginSocialEventFailure(error));
    }
  };
}

const beginSocialEventUnavailable = (data: { message: string, isSuccess: boolean }) => ({
  type: StoryletActionTypes.BEGIN_SOCIAL_EVENT_UNAVAILABLE,
  payload: {
    message: data.message,
    dialogOpen: !data.isSuccess,
  },
});

const beginSocialEventRequested = (invitationId: number) => ({
  type: StoryletActionTypes.BEGIN_SOCIAL_EVENT_REQUESTED,
  isFetching: true,
  invitationId,
  // phase: null
});

const beginSocialEventSuccess = (/* data */) => ({
  type: StoryletActionTypes.BEGIN_SOCIAL_EVENT_SUCCESS,
  isFetching: false,
  storylet: null,
  phase: 'In',
});

const beginSocialEventFailure = (error: any) => ({
  type: StoryletActionTypes.BEGIN_SOCIAL_EVENT_FAILURE,
  isFetching: false,
  error: true,
  status: error.response && error.response.status,
});